// extracted by mini-css-extract-plugin
module.exports = {"allocationSelector":"PortfolioAllocation_allocationSelector__3LP2g","title":"PortfolioAllocation_title__CzWwd"};